/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var windowW = $(window).width();
	var windowH = $(window).innerHeight();
	var _isSP = false;
	var _isipad = false;
	
	// テスト
	var _isTest = false;
	
	//preload
	
	(0, _module.preload)();
	
	//toggleHeader
	
	(0, _module.toggleHeader)();
	
	//pageTop
	
	(0, _module.pageTop)();
	
	//showMovie
	
	(0, _module.showMovie)();
	
	$(window).on('load', function () {
	
	  showComment();
	  scrollIndexAnime();
	
	  setTimeout(function () {
	    $('.index-Bg_Item_Orange').addClass("show");
	  }, 100);
	  setTimeout(function () {
	    $('#st-Header').removeClass("hidden");
	  }, 200);
	
	  $('.sw-Ttl-Lower').children(".txt").textyleF({
	    duration: 1000, //エフェクト時間(ミリ秒)
	    delay: 80, //文字間のエフェクト間隔(ミリ秒)
	    easing: 'cubic-bezier(0.16, 1, 0.3, 1)' //エフェクトのイージングパターン
	  });
	
	  if (_isTest) {
	
	    //アニメーション省略
	    // $('#index-Loader').remove();
	
	  } else {
	
	      // showKV();
	
	    }
	});
	
	// ------------------------------------------------------------------------
	// scrollIndexAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	var scrollIndexAnime = function scrollIndexAnime() {
	
	  var controller = new ScrollMagic.Controller();
	
	  //　スクロールで発火系
	  var targets = document.querySelectorAll(".js-scrollAnimation");
	  var targetsArray = Array.prototype.slice.call(targets); //Array
	  targetsArray.forEach(function (target) {
	    //シーンを作成
	    var scene3 = new ScrollMagic.Scene({
	      triggerElement: target,
	      triggerHook: .85
	    }).setClassToggle(target, "is-animated").addTo(controller);
	  });
	
	  //ロゴ調整
	  new ScrollMagic.Scene({
	    // triggerElement:'#entry',
	    triggerHook: 1,
	    offset: '120'
	  }).setClassToggle("#st-Header", "st-Header-small").addTo(controller);
	};
	
	// ------------------------------------------------------------------------
	// showComment
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showComment = function showComment() {
	  var $bg = $('#shop-Stage');
	
	  $('.js-shop').on('click', function () {
	
	    var dataShop = $(this).next('');
	    console.log(dataShop);
	    modalOpen(dataShop);
	  });
	
	  // モーダルを開く
	  function modalOpen(target) {
	
	    target.css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + '%', 'top': 0, 'left': 0 }, 300, 'easeOutQuart', function () {
	
	      // fadeIn
	      // $bg.stop().fadeIn(400);
	
	      // $('.shop-Box').addClass('show');
	      // target.addClass('is-show');
	
	      return false;
	    });
	  };
	
	  //close
	  $('.shop-Box_Close, .shop-Bg').on('click', function () {
	
	    $('.shop-Stage').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	
	      $('.shop-Stage').css({ 'display': 'none' });
	      // $('.shop-Box').removeClass('show');
	      // $('.shop-Box_Body').removeClass('is-show');
	    });
	  });
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var headerFlag = false;
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var headerButton = document.getElementById('st-Menu');
	
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	var preload = function preload() {
	
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	
	  //objectFit
	  objectFitImages();
	};
	
	// ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleHeader = function toggleHeader() {
	
	  headerButton.addEventListener('click', function () {
	
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      headerFlag = false;
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	var pageTop = function pageTop() {
	
	  $("#st-Footer_Top").on("click", function () {
	    var linkSpeed = 800;
	    $("html, body").animate({ scrollTop: 0 }, linkSpeed, "easeOutExpo");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showMovie = function showMovie() {
	  var $modal = $('#sw-Youtube');
	  var $content = $('#sw-Youtube_Content');
	
	  // open
	  $('.js-Youtube').on('click', function () {
	
	    var dataID = $(this).attr('data-youtube');
	
	    $('#sw-Youtube').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + 'vh', 'top': 0, 'left': 0 }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	      // fadeIn
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  });
	
	  //close
	  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function () {
	
	    $('#sw-Youtube').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $('#sw-Youtube').css({ 'display': 'none' });
	      $content.children('iframe').remove();
	    });
	  });
	};
	
	exports.preload = preload;
	exports.toggleHeader = toggleHeader;
	exports.pageTop = pageTop;
	exports.showMovie = showMovie;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bd-cd/app.bundle.js